import Amazon from '../../../public/assets/amazon.webp'
import BB from '../../../public/assets/bigbasket.webp'
import MG from '../../../public/assets/magenta.webp'
import fK from '../../../public/assets/flipkart.webp'
import fyn from '../../../public/assets/fyn.webp'
import rapido from '../../../public/assets/rapido.webp'
import zepto from '../../../public/assets/zepto.webp'
import swiggy from '../../../public/assets/swiggy.webp'
import zm from '../../../public/assets/zomato.webp'
import tally from '../../../public/assets/tally.webp'
import Image from 'next/image'
import DomainOutlinedIcon from '@mui/icons-material/DomainOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';

function Companies()
{
    let data=[
        {
            id:1,
            image:Amazon,
            name:"amazon",
            width:108,
            height:32
        },
        {
            id:2,
            image:BB,
            name:"bb",
            width:136,
            height:32
        },
        {
            id:3,
            image:MG,
            name:"mg",
            width:132,
            height:20
        },
        {
            id:4,
            image:fK,
            name:"fk",
            width:136,
            height:42
        },
        {
            id:5,
            image:fyn,
            name:"fyn",
            width:66,
            height:38
        },
        {
            id:6,
            image:rapido,
            name:"rapido",
            width:90,
            height:48
        },
        {
            id:7,
            image:zepto,
            name:"zepto",
            width:104,
            height:34
        },
        {
            id:8,
            image:swiggy,
            name:"swiggy",
            width:128,
            height:38
        },
        {
            id:9,
            image:zm,
            name:"zm",
            width:116,
            height:26
        },
        {
            id:10,
            image:tally,
            name:"tally",
            width:80,
            height:44
        },

    ]
    return <div id="companies" className="px-[32px] relative bottom-[44px]">
        <div className="font-noto-sans text-[32px] font-[600] leading-[31px] text-greyTitleBase900">Find jobs from top companies</div>
        <div className="grid grid-cols-2 md:grid md:grid-cols-5 mt-[32px] gap-[29px]">
        {
            data.map((item)=>{
                return <Image src={item.image.src} alt={item?.name} width={item.width} height={item.height} key={item?.name}/>
            })

        }

        </div>
        <div className='text-greyTertiaryBase500 text-center text-[16px] font-[400] leading-[15px] font-noto-sans pt-[16px]'>and many more</div>
        <div id="count1" className='flex gap-x-[16px] w-[100%] mt-[56px]'>
            <div id="recruiters" className='flex flex-col space-y-[29px] rounded-[24px] border-solid border-greyDisabledBackground50 p-[20px] custom-gradient w-[100%]'>
                <DomainOutlinedIcon sx={{
                    width:"40px",
                    height:"40px",
                    color:"#2286D9"
    
                }}/>
                <div>
                <div className='text-greyTitleBase900 font-noto-sans text-[20px] font-[600]'>350000+</div>
                <div className='text-greyTertiaryBase500 font-noto-sans text-[14px]'>Recruiters</div>

                </div>
 

            </div>
            <div id="candidates" className='flex flex-col space-y-[29px] rounded-[24px] border-solid border-greyDisabledBackground50 p-[20px] custom-gradient w-[100%]'>
                <PersonOutlinedIcon sx={{
                    width:"40px",
                    height:"40px",
                    color:"#2286D9"
    
                }}/>
    
                <div>
                <div className='text-greyTitleBase900 font-noto-sans text-[20px] font-[600]'>5500000+</div>
                <div className='text-greyTertiaryBase500 font-noto-sans text-[14px]'>Candidates</div>

                </div>
            </div>
        </div>
        <div id="count2">
        <div id="jobs-offered" className='flex flex-col space-y-[29px] rounded-[24px] border-solid border-greyDisabledBackground50 p-[20px] custom-gradient w-[100%] mt-[16px]'>
        <HandshakeOutlinedIcon sx={{
                    width:"40px",
                    height:"40px",
                    color:"#2286D9"
    
                }}/>
    
                <div>
                <div className='text-greyTitleBase900 font-noto-sans text-[20px] font-[600]'>750000+</div>
                <div className='text-greyTertiaryBase500 font-noto-sans text-[14px]'>Jobs Offered</div>

                </div>
        </div>
        </div>

    </div>

}
export default Companies